import { useGlobalSearchParams } from "expo-router";
import ShiftExpenseScreen from "@/components/screens/ShiftExpenseScreen";

export default function ExpensePage() {
  const { shift } = useGlobalSearchParams<{ shift?: string }>();

  if (!shift) return null;

  return <ShiftExpenseScreen shiftId={shift} />;
}
